import React, { useState } from "react";
import { ActivityIndicator } from "react-native";
import { Image } from "@gluestack-ui/themed";
import styled, { css } from "styled-components/native";

type ImageWithLoaderProps = {
  item: any;
  theme: any;
};

const ImageWithLoader = ({ item, theme }: ImageWithLoaderProps) => {
  const [loading, setLoading] = useState(true);
  return (
    <ImageParentContainer>
      {loading && (
        <ActivityIndicator
          size="large"
          color={theme["core-03"]}
          style={{
            position: "absolute",
            zIndex: 1,
          }}
        />
      )}
      <Image
        alt={item.overlay_text}
        source={{ uri: item.media }}
        resizeMode="cover"
        style={{
          width: "100%",
          height: "100%",
        }}
        onLoadEnd={() => setLoading(false)}
      />
    </ImageParentContainer>
  );
};

const ImageParentContainer = styled.View`
  position: relative;
  ${({ theme }) =>
    !theme.isMobile &&
    css`
      aspect-ratio: 686/468;
    `}
  ${({ theme }) =>
    theme.isMobile &&
    css`
      height: 100%;
    `}
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export default ImageWithLoader;
